import React, { useState } from 'react';

import moment from 'moment';

import YamlViewer from 'CommonComponents/YamlViewer';

import ChevronDown from 'Assets/icons/chevron-down.svg';
import ChevronUp from 'Assets/icons/chevron-up.svg';

export default function AuditLogsTableRow(props) {
    const [showDetails, setShowDetails] = useState(false);

    const logClasses = (type) => {
        let className = '';
        switch (type) {
            case 'Created':
                className += 'text-success';
                break;
            case 'Updated':
                className += 'text-primary';
                break;
            case 'Deleted':
                className += 'text-danger';
                break;
            default:
                className += 'text-muted';
        }

        return className;
    };

    function clickRow() {
        setShowDetails(!showDetails);
    }

    const combineHtml = (obj, keySuffix) => {
        if (obj === null || obj === undefined) {
            return '';
        }

        return Object.keys(obj).map((key) => {
            let val = obj[key];
            try {
                val = JSON.parse(val);
                val = JSON.stringify(val, undefined, 1);
            } catch (e) {
                console.log(e);
            }

            val = key === 'created_at' || key === 'updated_at' || key === 'date' ? moment(val).format('YYYY-MM-DD HH:mm:ss') : val;

            return (
                <div key={key + keySuffix}>
                    <pre>
                        {key}: {_.isArray(val) || _.isObject(val) ? JSON.stringify(val) : val}{' '}
                    </pre>
                </div>
            );
        });
    };

    const combineOldProperties = (properties, description) => {
        switch (description) {
            case 'Created':
                return <div>{$t('Created')}</div>;
            case 'Updated':
                return combineHtml(properties.old, 'old');
            case 'Deleted':
                return combineHtml(properties.attributes, 'old');
            default:
                return '';
        }
    };

    const combineNewProperties = (properties, description) => {
        switch (description) {
            case 'Created':
            case 'Updated':
                return combineHtml(properties.attributes, 'new');
            case 'Deleted':
                return <div>{$t('Deleted')}</div>;
            default:
                return '';
        }
    };

    return (
        <>
            <tr className={props.parent ? '' : '!tw-bg-white'}>
                <td>
                    {props.log.causer ? props.log.user : 'System'}
                    <>
                        {props.canBeExpanded && (
                            <span className="cursor-pointer" onClick={() => props.toggleVisible(props.log.batch_uuid)}>
                                {props.expanded && <ChevronUp className="tw-h-3 tw-w-3 tw-mx-auto tw-my-auto" />}
                                {!props.expanded && <ChevronDown className="tw-h-3 tw-w-3 tw-mx-auto tw-my-auto" />}
                            </span>
                        )}
                    </>
                </td>
                <td>{props.log.created_at}</td>
                <td>{props.log.subject_type}</td>
                <td>{props.log.desc}</td>
                <td>
                    {!!props.log.location.url && (
                        <a href={props.log.location.url} target={'_blank'} rel="noreferrer">
                            {props.log.location.text}
                        </a>
                    )}
                    {!props.log.location.url && props.log.location.text}
                </td>
                <td>
                    {!props.log.url && props.log.subject_name}
                    {!!props.log.url && (
                        <a href={props.log.url} target={'_blank'} rel="noreferrer">
                            {props.log.subject_name}
                        </a>
                    )}
                </td>
                <td>
                    <YamlViewer yamlString={props.log.old_values} />
                </td>
                <td>
                    <YamlViewer yamlString={props.log.new_values} />
                </td>
            </tr>
        </>
    );
}
